import { css } from '@emotion/css';
import { BaseStyle, Color, Display, Font, FontWeight, Spacing } from 'src/styles';

export const displayValue = css`
  cursor: pointer;
`;

export const copiedTooltip = css`
  .ant-tooltip-inner {
    ${Display.flex}
    background-color: ${Color.Gray2};
    ${BaseStyle.relative}
    border: 1px solid ${Color.Gray4};
    text-decoration: none;
    border-radius: 3px;
    ${Spacing.p12}
    ${Font.md}
    > i {
      font-size: 20px;
      ${FontWeight.bold}
      color: ${Color.Green6};
      ${Spacing.mr4}
    }
  }
  .ant-tooltip-arrow-content {
    --antd-arrow-background-color: ${Color.Gray2};
  }
`;
